<template>
  <div class="popup-modal">
    <div class="popup-modal__backdrop" />
    <div class="popup-modal__flex-wrapper" @click="$emit('close')">
      <div class="popup-modal__vertical-center">
        <div class="popup-modal__content">
          <slot name="body" />
        </div>
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent } from '@vue/composition-api';

export default defineComponent({
  name: 'EventPopupModal',
  emits: {
    close: () => true,
  },
});
</script>

<style lang="scss" scoped>
@import 'stylesheets/mixins';
@import 'stylesheets/variables';

.popup-modal {
  overflow-x: hidden;
  overflow-y: auto;
  position: fixed;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  z-index: $z-index-fg-popup;
  outline: 0;
}

.popup-modal__backdrop {
  position: fixed;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  background-color: black;
  opacity: 0.5;
  transition: opacity 0.15s linear;
}

.popup-modal__flex-wrapper {
  display: flex;
  position: relative;
  width: 100%;
  height: 100%;
}

.popup-modal__vertical-center {
  position: relative;
  margin: auto 0; // flexの親の中で縦にセンタリング
  width: 100%;

  // スマホでは画面下に張り付く
  @media screen and (max-width: 768px) {
    position: fixed;
    bottom: 0;
    margin: auto 0;
  }
}

.popup-modal__content {
  width: 640px;
  margin: 32px auto; // 縦に画面をはみ出すときにも上下に余白
  border-radius: 24px;
  position: relative;
  background-color: $oc-white;
  background-clip: padding-box;
  outline: 0;

  // スマホでは画面下に張り付くので上のみ角丸
  @media screen and (max-width: 768px) {
    margin: 0;
    width: 100%;
    border-radius: 10px 10px 0 0;
  }
}
</style>
